export default () => ({
    loading: false,
    tourGuides: [],
});

